import {
  Component,
  OnInit,
  DoCheck,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { PortfolioSurveyService } from "./../../_services/portfolio-survey.service";
import { CommonService } from "../../_services/common.service";
import { TabsetComponent } from "ngx-bootstrap/tabs";

@Component({
  selector: "app-labs",
  templateUrl: "./labs.component.html",
  styleUrls: ["./labs.component.scss"],
})
export class LabsComponent implements OnInit, DoCheck {
  @ViewChild("tabSet") tabSet: TabsetComponent;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private portfolioSurveyService: PortfolioSurveyService,
    private commonService: CommonService
  ) { }
  public domains;
  public filters = {};
  public cveDetails;
  public domain;
  public digitalRisk = [];
  public screennshots = [
    "https://i2.wp.com/hackersonlineclub.com/wp-content/uploads/2018/02/Networking.png?resize=662%2C396&ssl=1",
    "https://i.ytimg.com/vi/9N2fkh3fa10/maxresdefault.jpg",
  ];
  public showImage: boolean = false;
  public imageIndex: number = -1;
  public phishingDomains: any;
  public loadingRisk = false;
  public loadingPhishing = false;
  public totalLeakCredentialsCount;
  public vulnerabilitiesCount;
  public phishingCount;
  public maliciousCount;
  public leakedContentCount;
  public leakedContentCountNewValue: any;
  public leakedContents;
  public webDocumentCount;
  public webDocumentCountNewValue: any;
  public webDocuments;
  public total_cve_count;
  public subDomainsCount;
  public subDomainsCountOld;
  public whoisDetailsForRds;
  public automatedDone: boolean = false;
  public relatedDomainsHostsOld: any;
  public subDomains;
  public mainDomain;
  public maliciousList = [];
  public totalLeakCredentialsCountOld;
  public domainsLeakedCredentials: any;
  public relatedDomainsLeakCredentialsOld: any;
  public isUserTrial: boolean = false;
  public show3RdPartyTab: boolean = false;
  private userDomains = [];
  public buckets: any;
  public buckets_count: number;
  public codeLeaks: any;
  public showExecutiveReport: boolean = false;
  public setAssetView: boolean = false;
  public serviceVulnerabilties = [];
  public webVulnerabilties = [];
  public mobileVulnerabilties = [];
  public serviceVulCount;
  public mobileVulCount;
  public webVulCount;
  public pasteDataCount = -1;
  public loadMainDomain = false
  public showSpinnerForBucket = false
  public bucketCsvDetails = []
  public page = 1;
  public startDay: number = 365;
  public codeLeaksCount = 0;
  public filesData = {};
  public serviceLoader=true;
  public webVulLoader=true;

  ngOnInit() {
    this.getDomainName();

    // this.route.queryParams.subscribe(params => {
    // 	if (params && params['domain']) {
    // 		this.domain = params['domain'];
    // 		this.router.navigate(['.'], {
    // 			relativeTo: this.route, queryParams: { domain: this.domain }, queryParamsHandling: 'merge',
    // 			// preserve the existing query params in the route
    // 			skipLocationChange: true
    // 			// do not trigger navigation
    // 		});
    // 		this.getPhishing();
    // 		this.getDigitalRisk();
    // 		this.getBucketsForDomains();
    // 		// this.getCveDetailsForDomains()
    // 		// this.getRelatedDomainsSubDomains();
    // 		this.getVulnerabilityDeepc();
    // 		this.getMaliciousRisk();
    // 		this.getRelatedDomainsLeakCredentials();
    // 		this.getUserSelfDomain();
    // 		this.getCodeLeaksForDomain()

    // 	} else {
    // 		this.router.navigate(['/new/self-domains']);
    // 	}
    // })
  }
  filterDataOnDay(value) {
    const todayDate = new Date();
    if (value == null) {
      // this.filterRdsHosts();
      this.filters = {
        ...this.filters,
        ...{
          fromDate: new Date(
            todayDate.getTime() - this.startDay * 24 * 3600 * 1000
          ).toISOString(),
          toDate: new Date(todayDate.setDate(todayDate.getDate() + 1)).toISOString(),
        },
      };
    }
    else {
      this.filters = {}
      this.startDay=365
    }
    this.getAllData()
  }
  public getDomainName() {
    this.route.queryParams.subscribe((params) => {
      if (params && Object.keys(params).length > 0) {
        if (params["domain"]) {
          this.domain = params["domain"];
          this.router.navigate(["."], {
            relativeTo: this.route,
            queryParams: { domain: this.domain },
            queryParamsHandling: "merge",
            skipLocationChange: true,
          });
          this.getAllData();
        }
        if (params["activetab"]) {
          this.tabSet.tabs[1].active = true;
          this.setAssetView = true;
        }
      } else {
        this.portfolioSurveyService.getDomainsSearchForUser().subscribe(
          (data: any) => {
            data.filter((d) => {
              if (d["domain_type"] == "self") {
                this.domain = d["domain"];
                this.getAllData();
              }
            });
          },
          (error) => {
            this.errorForDomain(error);
          }
        );
      }
    });
  }
  public getAllData() {
    if (this.domain) {
      // this.getPhishing();
      // this.getDigitalRisk();
      this.getBucketsForDomains();
      // this.getCveDetailsForDomains()
      // this.getRelatedDomainsSubDomains();
      // this.getPasteDataCount();
      // this.getVulnerabilityDeepc();
      this.getMaliciousRisk();
      this.getRelatedDomainsLeakCredentials();
      // this.getUserSelfDomain();
      this.getCodeLeaksForDomain();
      // this.getServiceVulnerability();
      // this.getMobileAppVulnerability();
      // this.getWebAppVulnerability();
    } else {
      alert(
        "No domain associated with you, Please write us on contact@firecompass.com"
      );
    }
  }

  setUserAccount(userAccount) {
    if (userAccount && userAccount == "trial") {
      this.isUserTrial = true;
    }
  }

  getVulnerabilityDeepc() {
    const params = {
      ...this.filters
    }
    this.portfolioSurveyService.getVulnerabilityDeepc(this.domain, params).subscribe(
      (data: any) => {
        if (data && data["status"] == "pass") {
          this.setUserAccount(data["userAccount"]);
          this.cveDetails = data["data"];
          this.total_cve_count = data["vulnerabilities_count"];
        }
      },
      (error) => {
        this.errorForDomain(error);
      }
    );
  }

  // leakContentCountChange(value) {
  //   this.leakedContentCountNewValue = value;
  // }

  ngDoCheck() {
    // this.leakedContentCount = this.leakedContentCountNewValue ? this.leakedContentCountNewValue : '0';
  }

  getRelatedDomainsLeakCredentials() {
    this.portfolioSurveyService
      .getRelatedDomainsLeakCredentials(this.domain)
      .subscribe(
        (data: any) => {
          if (data) {
            if (data["leak_credentials"]) {
              this.setUserAccount(data["userAccount"]);
              this.totalLeakCredentialsCount = data["leak_credentials"][
                "total_leaked_credentials"
              ]
                ? data["leak_credentials"]["total_leaked_credentials"]
                : 0;
              this.domainsLeakedCredentials = data["leak_credentials"]["data"];
              this.mainDomain = data.domain;
              if (this.mainDomain) this.loadMainDomain = true
              if (
                data["leak_credentials"]["status"] == "fail" ||
                !this.totalLeakCredentialsCount
              ) {
                this.getAutomatedData();
              } else {
                this.domainsLeakedCredentials.forEach((element) => {
                  this.commonService.checkCreatedAndUpdated(element);
                });
                this.relatedDomainsLeakCredentialsOld = this.domainsLeakedCredentials.slice();
                this.totalLeakCredentialsCountOld = this.totalLeakCredentialsCount;
              }
            }
          }
        },
        (error) => {
          this.errorForDomain(error);
        }
      );
  }

  getMaliciousRisk() {
    const params = {
      ...this.filters
    }
    this.loadingRisk = true;
    this.portfolioSurveyService.getMaliciousRisk(this.domain, params).subscribe(
      (data) => {
        if (data) {
          this.setUserAccount(data["userAccount"]);
          this.loadingRisk = false;
          this.maliciousCount = data["count"];
          this.maliciousList = data["data"];
        }
      },
      (error) => {
        console.log(
          "Error while loading risks. Please try again after sometime!"
        );
        this.errorForDomain(error);
      }
    );
  }

  getDigitalRisk() {
    this.loadingRisk = true;
    this.portfolioSurveyService.getDigitalRisk(this.domain).subscribe(
      (data: any) => {
        if (data) {
          this.setUserAccount(data["userAccount"]);
          this.digitalRisk = data.data;
          this.loadingRisk = false;
          this.leakedContents = data["leak_contents"];
          this.leakedContentCount = data["count_leaked_content"];
          this.webDocuments = data["cloud_documents"];
          this.webDocumentCount = this.webDocuments.length;
        }
      },
      (error) => {
        alert("Error while loading risks. Please try again after sometime!");
        this.errorForDomain(error);
      }
    );
  }

  screenshots(i) {
    this.showImage = true;
  }

  getPhishing() {
    this.loadingPhishing = true;
    this.portfolioSurveyService.getPhishingDomains(this.domain).subscribe(
      (data) => {
        if (data) {
          this.setUserAccount(data["userAccount"]);
          this.loadingPhishing = false;
          this.phishingDomains = data["data"];
          this.phishingCount = data["count"];
        }
      },
      (error) => {
        this.loadingPhishing = false;
        this.errorForDomain(error);
      }
    );
  }

  errorForDomain(error) {
    if (error.status == 403) {
      alert(
        "Forbidden! You are not allowed to perform this action. Please contact us at contact@firecompass.com"
      );
      this.router.navigate(["/new/self-domains"]);
    }
  }
  updateTotalCvCount(count) {
    this.total_cve_count = count;
    // if (count != undefined && count != null)
    // 	document.getElementById('totalCveCount').innerText = count;
  }

  getCveDetailsForDomains() {
    this.portfolioSurveyService
      .getCveDetailsForDomains(this.domain)
      .subscribe((data) => {
        if (data && data["status"] == "pass") {
          this.setUserAccount(data["userAccount"]);
          this.cveDetails = data["data"];
          this.total_cve_count = data["total_cve_count"];
        }
      });
  }
  getBucketsForDomains() {
    this.showSpinnerForBucket = true
    const params = {
      "page": this.page,
      ...this.filters
    }
    this.portfolioSurveyService.getCloudBuckets(this.domain, params).subscribe((data) => {
      if (data) {
        // this.setUserAccount(data["userAccount"]);
        this.buckets = data["results"];
        this.buckets_count = data["count"];
        this.getCSVdata()
        this.getFilesCount(this.buckets)
        this.showSpinnerForBucket = false
      } else this.showSpinnerForBucket = false
    }, (error) => {
      this.showSpinnerForBucket = false
    }
    );
  }


  getFilesCount(bucket_data){
		var bucketNames = []
		var buckeNameStr = null;
		bucket_data.forEach(element => {
		  bucketNames.push(element['bucket_name'])
		  
		});
		buckeNameStr = bucketNames.join()
		this.portfolioSurveyService.getFileCount(this.domain,buckeNameStr).subscribe((data) => {
		  if(data){
			this.filesData=data['data']
	
		  }
		})
	  }




  getCSVdata() {
    this.bucketCsvDetails = []
    const params = {
      limit: this.buckets_count,
      page_size: this.buckets_count
    }
    this.portfolioSurveyService.getBuckets(this.domain, params).subscribe((data: any) => {
      if (data) {
        this.bucketCsvDetails = data['data'];
      }
    })
  }
  getRelatedDomainsSubDomains() {
    this.portfolioSurveyService
      .getRelatedDomainsSubDomains(this.domain)
      .subscribe(
        (data: any) => {
          if (data) {
            this.setUserAccount(data["userAccount"]);
            this.domains = data.related_domains["data"];
            this.mainDomain = data.domain["data"];
            this.subDomainsCount = data.related_domains.total_sub_domain_count;
            this.subDomainsCountOld = this.subDomainsCount;
            this.whoisDetailsForRds = data["additional_RD_details"];
            if (
              data["related_domains"]["status"] == "fail" ||
              !this.domains ||
              !this.domains.length ||
              !this.subDomainsCount
            ) {
              this.getAutomatedData();
            } else {
              this.domains.forEach((element) => {
                this.commonService.checkCreatedAndUpdated(element);
                element.hosts.forEach((host) => {
                  this.commonService.checkCreatedAndUpdated(host);
                });
              });
              this.relatedDomainsHostsOld = JSON.parse(
                JSON.stringify(this.domains)
              );
            }
          }
        },
        (error) => {
          this.errorForDomain(error);
        }
      );
  }

  getAutomatedData() {
    // if (!this.automatedDone) {
    this.automatedDone = true;
    // 	this.portfolioSurveyService.getAutomatedDataForDomain(this.domain).subscribe(data => {
    // 		if (data) {
    // 			console.log(data);
    // 		}
    // 	})
    // }
  }

  getUserSelfDomain() {
    this.portfolioSurveyService
      .getDomainsSearchForUser()
      .subscribe((data: any) => {
        var index = -1;
        data.forEach((d, i) => {
          if (d["domain"] == this.domain && d["domain_type"] == "self") {
            this.show3RdPartyTab = true;
            index = i;
          }
        });
        if (index != -1) {
          data.splice(index, 1);
        }
        this.userDomains = data;
      });
  }
  public getCodeLeaksForDomain() {
    const params = {
      "page": 1,
      "limit": 10,
      ...this.filters
    }
    this.portfolioSurveyService
      .getCodeLeaks(this.domain, params)
      .subscribe((data: any) => {
        if (data && data["status"] == "pass") {
          this.codeLeaksCount = data["count"]
          this.codeLeaks = data["data"];
          console.log("I am done printing", this.mainDomain, this.codeLeaks)
          this.setUserAccount(data["userAccount"]);
        }
      }, error => {
        if (error['status'] === 403) {
          alert("You do not have permission to perform this action. Please write to us at contact@firecompass.com.")
        } else {
          alert("Error while getting code leaks!")
        }

      });
  }
  getServiceVulnerability() {
    var params = {
      "page": this.page,
      "limit": 10,
      ...this.filters
    }
    this.portfolioSurveyService
      .getServiceVulnerability(this.domain, params)
      .subscribe((vul) => {
        this.serviceVulnerabilties = vul["data"];
        this.serviceVulCount = this.serviceVulnerabilties.length
          ? this.serviceVulnerabilties[0]['total']
          : 0;
        this.serviceLoader=false
        });
  }

  getWebAppVulnerability() {
    var params = {
      "page": this.page,
      "limit": 10,
      ...this.filters
    }
    this.portfolioSurveyService
      .getWebAppVulnerability(this.domain, params)
      .subscribe((vul) => {
        this.webVulnerabilties = vul["data"];
        this.webVulCount = this.webVulnerabilties.length
          ? this.webVulnerabilties[0]['total']
          : 0;
          this.webVulLoader=false
      });
  }
  getMobileAppVulnerability() {
    this.portfolioSurveyService
      .getMobileAppVulnerability(this.domain)
      .subscribe((vul) => {
        this.mobileVulnerabilties = vul["data"];
        this.mobileVulCount = this.mobileVulnerabilties.length
          ? this.mobileVulnerabilties.length
          : 0;
      });
  }
  getPasteDataCount() {
    const params = {
      ...this.filters
    }
    this.portfolioSurveyService
      .getPasteDataCount(this.domain, params)
      .subscribe((data) => {
        if (data && data["status"] == "pass") {
          this.pasteDataCount = data["count"];
        }
      });
  }
  refreshCount(e){
    console.log('refreshCount',e);
    if(e=="network"){
      this.getServiceVulnerability();
    }else if(e=="webapp"){
      this.getWebAppVulnerability();
    }else if(e=="ip"){
      this.getMaliciousRisk();
    }
  }
}
